import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import React from 'react'

import { getUrlByDomain } from '@js/common/getUrlByDomain'

import { InternalLinkWithWT } from '@f-fertighaus/applications/Next/components/common/InternalLink'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { Review } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/components/Review'

export const ReviewsSection = () => {
  const { vendor, state, domain, reviewsActive } = useHouseDetail()
  const getUrl = getUrlByDomain(domain)

  if (!state.review_data?.results?.length || !reviewsActive) {
    return null
  }

  return (
    <ReviewsSectionWrapper>
      <Typography variant='bodyTitle' marginBottom={2} component='p'>
        {t('houseDetailPage.vendor.reviews-section', {
          vendorName: vendor.display_name
        })}
      </Typography>
      <ReviewsBox>
        {state.review_data.results.map(review => (
          <Review key={review.nid} {...review} />
        ))}
      </ReviewsBox>
      <CTAWrapper>
        <InternalLinkWithWT
          href={`${getUrl('vendorDetail')(vendor.slug)}#reviews`}
          wtPayload={{
            category: 'CTA-link',
            action: 'click',
            label: 'view-vendor-reviews',
            location: 'vendor-section',
            values: [
              {
                type: 'text',
                value: t('houseDetailPage.vendor.all-reviews')
              },
              { type: 'url', value: getUrl('vendorDetail')(vendor.slug) }
            ]
          }}>
          {t('houseDetailPage.vendor.all-reviews')}
        </InternalLinkWithWT>
      </CTAWrapper>
    </ReviewsSectionWrapper>
  )
}

const ReviewsSectionWrapper = styled.div`
  margin-top: 16px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: 32px;
  }
`

const ReviewsBox = styled.div`
  display: flex;
  column-gap: 16px;
  overflow: auto;
`

const CTAWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: 16px;
  }
`
